@layer token {
  :root {
    /* BASE ----------------------------------------------------------------- */

    --n-button-border-width: var(--n-border-width-025);
    --n-button-border-radius: var(--n-radius-action-default);

    --n-button-focus-ring-color: var(--n-color-border-focus-ring);
    --n-button-focus-ring-offset: var(--n-focus-ring-offset);
    --n-button-focus-ring-style: var(--n-focus-ring-style);
    --n-button-focus-ring-width: var(--n-focus-ring-width);

    --n-button-font-family: var(--n-font-family-base);
    --n-button-font-size-sm: var(--n-font-size-350);
    --n-button-font-size-md: var(--n-font-size-350);
    --n-button-font-size-lg: var(--n-font-size-400);
    --n-button-font-weight: var(--n-font-weight-600);

    --n-button-gap: var(--n-scale-200);

    --n-button-height-sm: var(--n-scale-800);
    --n-button-height-md: var(--n-scale-1000);
    --n-button-height-lg: var(--n-scale-1200);

    --n-button-padding-block-sm: var(--n-scale-150);
    --n-button-padding-inline-sm: var(--n-scale-300);
    --n-button-padding-block-md: 10px;
    --n-button-padding-inline-md: var(--n-scale-300);
    --n-button-padding-block-lg: 14px;
    --n-button-padding-inline-lg: var(--n-scale-400);

    --n-button-lh-sm: var(--n-font-line-height-500);
    --n-button-lh-md: var(--n-font-line-height-500);
    --n-button-lh-lg: var(--n-font-line-height-600);

    /* PRIMARY VARIANT ------------------------------------------------------ */

    --n-button-primary-bg-color: var(
      --n-color-component-action-primary-fill-default
    );
    --n-button-primary-bg-color-pressed: var(
      --n-color-component-action-primary-fill-pressed
    );
    --n-button-primary-bg-color-disabled: var(
      --n-color-component-action-fill-disabled
    );
    --n-button-primary-bg-color-hover: var(
      --n-color-component-action-primary-fill-hover
    );

    --n-button-primary-border-color: var(--n-color-neutral-alpha-000);
    --n-button-primary-border-color-pressed: var(--n-color-neutral-alpha-000);
    --n-button-primary-border-color-disabled: var(--n-color-neutral-alpha-000);
    --n-button-primary-border-color-hover: var(--n-color-neutral-alpha-000);

    --n-button-primary-shadow:
      0 1px 0 0 rgba(var(--rgb-white), 0.25) inset,
      -1px 0 0 0 rgba(var(--rgb-black), 0.25) inset,
      1px 0 0 0 rgba(var(--rgb-black), 0.25) inset,
      0 -1px 0 0 rgba(var(--rgb-black), 0.25) inset, var(--n-shadow-100);

    --n-button-primary-font-color: var(
      --n-color-component-action-primary-content-default
    );
    --n-button-primary-font-color-disabled: var(
      --n-color-component-action-content-disabled
    );

    /* SECONDARY VARIANT ---------------------------------------------------- */

    --n-button-secondary-bg-color: var(
      --n-color-component-action-secondary-fill-default-transparent
    );
    --n-button-secondary-bg-color-pressed: var(
      --n-color-component-action-secondary-fill-pressed
    );
    --n-button-secondary-bg-color-hover: var(
      --n-color-component-action-secondary-fill-hover
    );
    --n-button-secondary-bg-color-disabled: var(
      --n-color-component-action-secondary-fill-default-transparent
    );

    --n-button-secondary-border-color: var(
      --n-color-component-action-secondary-border-default
    );
    --n-button-secondary-border-color-pressed: var(
      --n-color-component-action-secondary-border-default
    );
    --n-button-secondary-border-color-disabled: var(
      --n-color-component-action-border-disabled
    );
    --n-button-secondary-border-color-hover: var(
      --n-color-component-action-secondary-border-default
    );

    --n-button-secondary-shadow: var(--n-shadow-100);

    --n-button-secondary-font-color: var(
      --n-color-component-action-content-default
    );
    --n-button-secondary-font-color-disabled: var(
      --n-color-component-action-content-disabled
    );

    /* TERTIARY VARIANT ---------------------------------------------------- */

    --n-button-tertiary-bg-color: var(
      --n-color-component-action-tertiary-fill-default
    );
    --n-button-tertiary-bg-color-pressed: var(
      --n-color-component-action-tertiary-fill-pressed
    );
    --n-button-tertiary-bg-color-hover: var(
      --n-color-component-action-tertiary-fill-hover
    );
    --n-button-tertiary-bg-color-disabled: var(
      --n-color-component-action-tertiary-fill-default
    );

    --n-button-tertiary-border-color: var(--n-color-neutral-alpha-000);
    --n-button-tertiary-border-color-pressed: var(--n-color-neutral-alpha-000);
    --n-button-tertiary-border-color-disabled: var(--n-color-neutral-alpha-000);
    --n-button-tertiary-border-color-hover: var(--n-color-neutral-alpha-000);

    --n-button-tertiary-shadow: var(--n-shadow-000);

    --n-button-tertiary-font-color: currentColor;
    --n-button-tertiary-font-color-disabled: var(
      --n-color-component-action-content-disabled
    );

    /* PLAIN VARIANT ------------------------------------------------------- */

    --n-button-plain-font-color: var(
      --n-color-component-action-plain-content-default
    );
    --n-button-plain-font-color-pressed: var(
      --n-color-component-action-plain-content-pressed
    );
    --n-button-plain-font-color-disabled: var(
      --n-color-component-action-content-disabled
    );
    --n-button-plain-font-color-hover: var(
      --n-color-component-action-plain-content-hover
    );

    /* DESTRUCTIVE MODE ----------------------------------------------------- */

    --n-button-primary-destructive-bg-color: var(
      --n-color-component-action-primary-fill-destructive-default
    );
    --n-button-primary-destructive-bg-color-hover: var(
      --n-color-component-action-primary-fill-destructive-hover
    );
    --n-button-primary-destructive-bg-color-pressed: var(
      --n-color-component-action-primary-fill-destructive-pressed
    );

    --n-button-secondary-destructive-font-color: var(
      --n-color-component-action-secondary-content-destructive-default
    );

    --n-button-tertiary-destructive-bg-color: var(
      --n-color-component-action-tertiary-fill-destructive-default
    );
    --n-button-tertiary-destructive-bg-color-hover: var(
      --n-color-component-action-tertiary-fill-hover
    );
    --n-button-tertiary-destructive-bg-color-pressed: var(
      --n-color-component-action-tertiary-fill-pressed
    );
    --n-button-tertiary-destructive-font-color: var(
      --n-color-component-action-tertiary-content-destructive-default
    );
    --n-button-tertiary-destructive-font-color-hover: var(
      --n-color-component-action-tertiary-content-destructive-default
    );
    --n-button-tertiary-destructive-font-color-pressed: var(
      --n-color-component-action-tertiary-content-destructive-default
    );

    --n-button-plain-destructive-font-color: var(
      --n-color-component-action-plain-content-destructive-default
    );
    --n-button-plain-destructive-font-color-hover: var(
      --n-color-component-action-plain-content-destructive-hover
    );
    --n-button-plain-destructive-font-color-pressed: var(
      --n-color-component-action-plain-content-destructive-pressed
    );

    /* DEFAULT SHAPE -------------------------------------------------------- */

    --n-button-default-min-width: 68px;

    /* ICON SHAPE ----------------------------------------------------------- */

    --n-button-icon-border-radius: var(--n-button-border-radius);
    --n-button-icon-size-sm: var(--n-scale-800);
    --n-button-icon-size-md: var(--n-scale-1000);
    --n-button-icon-size-lg: var(--n-scale-1200);

    /* MICRO SHAPE ---------------------------------------------------------- */

    --n-button-micro-border-radius: var(--n-border-radius-max);
    --n-button-micro-size-xs: var(--n-scale-400);
    --n-button-micro-size-sm: var(--n-scale-500);
  }
}

@layer component {
  /* BASE ------------------------------------------------------------------- */

  .button {
    user-select: none;
    backface-visibility: hidden;
    position: relative;
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    width: fit-content;
    max-width: 480px;
    white-space: nowrap;
    overflow: hidden;
    padding: 0;
    text-box: trim-both cap alphabetic;
    text-decoration: none;
    text-overflow: ellipsis;
    border-radius: var(--n-button-border-radius);
    border-style: solid;
    border-width: var(--n-button-border-width);
    font-family: var(--n-button-font-family);
    font-weight: var(--n-button-font-weight);
  }

  .children {
    pointer-events: none;
    display: flex;
    width: 100%;
    flex-shrink: 0;
    gap: var(--n-button-gap);
    align-items: center;
    justify-content: center;
  }

  .loader {
    visibility: hidden;
    width: 100%;
  }

  /* VARIANTS --------------------------------------------------------------- */

  .primaryVariant {
    background-color: var(--n-button-primary-bg-color);
    border-color: var(--n-button-primary-border-color);
    box-shadow: var(--n-button-primary-shadow);
    color: var(--n-button-primary-font-color);

    &.destructiveMode {
      background-color: var(--n-button-primary-destructive-bg-color);
      color: var(
        --n-color-component-action-primary-content-destructive-default
      );
    }
  }

  .secondaryVariant {
    background-color: var(--n-button-secondary-bg-color);
    border-color: var(--n-button-secondary-border-color);
    box-shadow: var(--n-button-secondary-shadow);
    color: var(--n-button-secondary-font-color);

    &.destructiveMode {
      background-color: var(--n-button-secondary-bg-color);
      color: var(--n-button-secondary-destructive-font-color);
    }
  }

  .tertiaryVariant {
    background-color: var(--n-button-tertiary-bg-color);
    border-color: var(--n-button-tertiary-border-color);
    box-shadow: var(--n-button-tertiary-shadow);
    color: var(--n-button-tertiary-font-color);

    &.destructiveMode {
      background-color: var(--n-button-tertiary-destructive-bg-color);
      color: var(
        --n-color-component-action-secondary-content-destructive-default
      );
    }
  }

  .plainVariant {
    padding: var(--n-scale-025);
    border-color: transparent;
    background-color: transparent;
    color: var(--n-button-plain-font-color);

    &.destructiveMode {
      color: var(--n-color-component-action-plain-content-destructive-default);
    }
  }

  /* SHAPES ----------------------------------------------------------------- */

  .defaultShape {
    /* Standard button shape - inherits base button styles */
    min-width: var(--n-button-default-min-width);
  }

  .iconShape {
    flex: 0 0 auto;
    border-radius: var(--n-button-icon-border-radius);
  }

  .microShape {
    border-radius: var(--n-button-micro-border-radius);
    border: 0;
    background-color: var(--n-button-micro-bg-color);
  }

  /* SIZES ------------------------------------------------------------------ */

  .xsSize {
    &.microShape {
      width: var(--n-button-micro-size-xs);
      height: var(--n-button-micro-size-xs);
      padding: 0;
    }
  }

  .smSize {
    font-size: var(--n-button-font-size-sm);
    line-height: var(--n-button-lh-sm);

    &:not(.plainVariant) {
      height: var(--n-button-height-sm);
      padding-block: var(--n-button-padding-block-sm);
      padding-inline: var(--n-button-padding-inline-sm);
    }

    &.iconShape {
      width: var(--n-button-icon-size-sm);
      height: var(--n-button-icon-size-sm);
      font-size: var(--n-button-icon-font-size-sm);
    }

    &.microShape {
      width: var(--n-button-micro-size-sm);
      height: var(--n-button-micro-size-sm);
      padding: 0;
    }
  }

  .mdSize {
    font-size: var(--n-button-font-size-md);
    line-height: var(--n-button-lh-md);

    &:not(.plainVariant) {
      height: var(--n-button-height-md);
      padding-block: var(--n-button-padding-block-md);
      padding-inline: var(--n-button-padding-inline-md);
    }

    &.iconShape {
      width: var(--n-button-icon-size-md);
      height: var(--n-button-icon-size-md);
    }
  }

  .lgSize {
    font-size: var(--n-button-font-size-lg);
    line-height: var(--n-button-lh-lg);

    &:not(.plainVariant) {
      height: var(--n-button-height-lg);
      padding-block: var(--n-button-padding-block-lg);
      padding-inline: var(--n-button-padding-inline-lg);
    }

    &.iconShape {
      width: var(--n-button-icon-size-lg);
      height: var(--n-button-icon-size-lg);
    }
  }

  /* FULL WIDTH ------------------------------------------------------------- */

  .isFullWidth {
    width: 100%;
    max-width: unset;
  }
}

@layer state {
  /* DISABLED ---------------------------------------------------------------- */

  .button:disabled {
    cursor: not-allowed; /* We only show not-allowed for fully disabled buttons */
  }

  .button:disabled,
  .button[aria-disabled='true'] {
    box-shadow: var(--n-box-shadow-000); /* none */

    &.primaryVariant {
      background-color: var(--n-button-primary-bg-color-disabled);
      border-color: var(--n-button-primary-border-color-disabled);
      color: var(--n-button-primary-font-color-disabled);
    }

    &.secondaryVariant {
      background-color: var(--n-button-secondary-bg-color-disabled);
      border-color: var(--n-button-secondary-border-color-disabled);
      color: var(--n-button-secondary-font-color-disabled);
    }

    &.tertiaryVariant {
      background-color: var(--n-button-tertiary-bg-color-disabled);
      border-color: var(--n-button-tertiary-border-color-disabled);
      color: var(--n-button-tertiary-font-color-disabled);
    }

    &.plainVariant {
      color: var(--n-button-plain-font-color-disabled);
    }

    &.iconShape {
    }
  }

  /* LOADING ----------------------------------------------------------------- */

  .isLoading .children {
    visibility: hidden;
  }

  .isLoading .loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    visibility: visible;
  }

  .secondaryVariant.isLoading {
    background-color: var(--n-button-secondary-bg-color-pressed);
  }

  /* HOVER ------------------------------------------------------------------- */

  @media (--mq-hover) {
    .button:hover:not(.isLoading):not([aria-disabled='true']) {
      cursor: pointer;

      &.primaryVariant {
        background-color: var(--n-button-primary-bg-color-hover);
        border-color: var(--n-button-primary-border-color-hover);

        &.destructiveMode {
          background-color: var(--n-button-primary-destructive-bg-color-hover);
        }
      }

      &.secondaryVariant {
        background-color: var(--n-button-secondary-bg-color-hover);
        border-color: var(--n-button-secondary-border-color-hover);
      }

      &.tertiaryVariant {
        background-color: var(--n-button-tertiary-bg-color-hover);
        border-color: var(--n-button-tertiary-border-color-hover);

        &.destructiveMode {
          background-color: var(--n-button-tertiary-destructive-bg-color-hover);
          color: var(--n-button-tertiary-destructive-font-color-hover);
        }
      }

      &.plainVariant {
        color: var(--n-button-plain-font-color-hover);

        &.destructiveMode {
          color: var(--n-button-plain-destructive-font-color-hover);
        }
      }

      &.iconShape {
      }

      &.microShape {
      }
    }
  }

  /* ACTIVE / EXPANDED ------------------------------------------------------- */

  .button:active:not(.isLoading):not([aria-disabled='true']),
  .button[aria-expanded='true']:not(.isLoading):not([aria-disabled='true']) {
    &.primaryVariant {
      background-color: var(--n-button-primary-bg-color-pressed);
      border-color: var(--n-button-primary-border-color-pressed);

      &.destructiveMode {
        background-color: var(--n-button-primary-destructive-bg-color-pressed);
      }
    }

    &.secondaryVariant {
      background-color: var(--n-button-secondary-bg-color-pressed);
      border-color: var(--n-button-secondary-border-color-pressed);
    }

    &.tertiaryVariant {
      background-color: var(--n-button-tertiary-bg-color-pressed);
      border-color: var(--n-button-tertiary-border-color-pressed);

      &.destructiveMode {
        background-color: var(--n-button-tertiary-destructive-bg-color-pressed);
        color: var(--n-button-tertiary-destructive-font-color-pressed);
      }
    }

    &.plainVariant {
      color: var(--n-button-plain-font-color-pressed);

      &.destructiveMode {
        color: var(--n-button-plain-destructive-font-color-pressed);
      }
    }

    &.iconShape {
    }

    &.microShape {
    }
  }

  /* FOCUS ------------------------------------------------------------------- */

  .button:focus-visible {
    outline-offset: var(--n-button-focus-ring-offset);
    outline-style: var(--n-button-focus-ring-style);
    outline-width: var(--n-button-focus-ring-width);
    outline-color: var(--n-button-focus-ring-color);

    &.primaryVariant:not([aria-disabled='true']) {
      background-color: var(--n-button-primary-bg-color-hover);

      &.destructiveMode {
        background-color: var(--n-button-primary-destructive-bg-color-hover);
      }
    }

    &.secondaryVariant:not([aria-disabled='true']) {
      background-color: var(--n-button-secondary-bg-color-hover);
    }

    &.tertiaryVariant:not([aria-disabled='true']) {
      background-color: var(--n-button-tertiary-bg-color-hover);
    }
  }
}
